export default {"src":"/_next/static/media/0x1A3496C18d558bd9C6C8f609E1B129f67AB08163.1da49cdb.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};